import appendSlide from '/expert/mobile/methods/appendSlide.js';
import prependSlide from '/expert/mobile/methods/prependSlide.js';
import addSlide from '/expert/mobile/methods/addSlide.js';
import removeSlide from '/expert/mobile/methods/removeSlide.js';
import removeAllSlides from '/expert/mobile/methods/removeAllSlides.js';

export default function Manipulation({ swiper }) {
  Object.assign(swiper, {
    appendSlide: appendSlide.bind(swiper),
    prependSlide: prependSlide.bind(swiper),
    addSlide: addSlide.bind(swiper),
    removeSlide: removeSlide.bind(swiper),
    removeAllSlides: removeAllSlides.bind(swiper),
  });
}
